var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "times"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.06 6.00002L11.48 1.58002C11.5537 1.51136 11.6128 1.42856 11.6538 1.33656C11.6948 1.24456 11.7168 1.14525 11.7186 1.04454C11.7204 0.943839 11.7018 0.84381 11.6641 0.750422C11.6264 0.657034 11.5703 0.5722 11.499 0.500981C11.4278 0.429762 11.343 0.373618 11.2496 0.335897C11.1562 0.298176 11.0562 0.279651 10.9555 0.281428C10.8548 0.283205 10.7555 0.305247 10.6635 0.346239C10.5715 0.38723 10.4887 0.446333 10.42 0.520019L6 4.94002L1.58 0.520019C1.43782 0.387539 1.24978 0.315416 1.05548 0.318844C0.861176 0.322272 0.67579 0.400985 0.538377 0.538398C0.400964 0.675811 0.322252 0.861196 0.318824 1.0555C0.315396 1.2498 0.387519 1.43784 0.519999 1.58002L4.94 6.00002L0.519999 10.42C0.379549 10.5606 0.300659 10.7513 0.300659 10.95C0.300659 11.1488 0.379549 11.3394 0.519999 11.48C0.660624 11.6205 0.851249 11.6994 1.05 11.6994C1.24875 11.6994 1.43937 11.6205 1.58 11.48L6 7.06002L10.42 11.48C10.5606 11.6205 10.7512 11.6994 10.95 11.6994C11.1488 11.6994 11.3394 11.6205 11.48 11.48C11.6204 11.3394 11.6993 11.1488 11.6993 10.95C11.6993 10.7513 11.6204 10.5606 11.48 10.42L7.06 6.00002Z",
    fill: "#1F2937"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.1b526eb175bee10201a7558918c7f708.svg";
export { ForwardRef as ReactComponent };